import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, of, Subject} from 'rxjs';
import {MmcInventoryColumnsService} from "@irb/irb-models/model-market-center/mmc-inventory/mmc-inventory-columns.service";
import {AssignedAccountCount, IRebalResponseObject} from "@irb/irb-clients/irb-clients.model";
import {map} from "rxjs/operators";
import {AppService} from "@irb/app.service";

@Injectable({
    providedIn: "root"
})
export class MmcInventoryService {
    payload: any = {};
    public httpOptions: any = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        })
    };
    subscribeBanner = new Subject<any>();
    filterAfterSubscribe = new Subject<any>();
    params: any;
    mmcServiceUrlPrefix = '/mmc';

    constructor(public _http: HttpClient,
                public mmcColsService: MmcInventoryColumnsService, private as: AppService) {

        const useModelMarketService = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_MMC_APIS || false;
        if (useModelMarketService)
            this.mmcServiceUrlPrefix = '/model-market-service';
    }

    getMMCModelInventory(params: any): Observable<Object> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
            'X-HTTP-Method-Override':'GET',
            'Filter-Item':'items=' + params.request.startRow + '-' + (--params.request.endRow)
        });
        this.payload = {};
        let sort = '';
        if (params.request.sortModel.length > 0) {
            let sortColumn = params.request.sortModel[0].colId;
            const sortOrder = (params.request.sortModel[0].sort === 'asc') ? '+' : '-';
            sort = sortOrder + sortColumn;
            this.payload.sort = sort;
        }
        let filterKeys = '';
        if (params.request.filterModel && params.request.filterModel['modelMarketName']) {
            if (params.request.filterModel['modelMarketName'].filter) {
                // filterKeys = filterKeys + '&modelMarketName=' + params.request.filterModel['modelMarketName'].filter;
                const encodedName = encodeURIComponent(params.request.filterModel['modelMarketName'].filter);

                filterKeys = filterKeys + "&modelMarketName%3D" + encodedName;
            }
        }
        if (params.request.filterModel && params.request.filterModel['modelProviderName']) {
            if (params.request.filterModel['modelProviderName'].values) {
                let keyIds: any[] = [];
                params.request.filterModel['modelProviderName'].values.forEach((value:any)=>{
                    let items = this.mmcColsService.modelProvidersListUnaltered.filter(y=>value.includes(y.name?.trim()));
                    if(items && items.length > 0) {
                        items.forEach((prov: any) => {
                            if(keyIds.indexOf(prov.id) === -1) {
                                keyIds.push(prov.id);
                            }
                        });
                    }
                });
                // filterKeys = filterKeys + '&modelProviderId=' + params.request.filterModel['modelProviderName'].values
                //   .map((value: any) => this.mmcColsService.mapModelProvidersReversed.get(value));
                filterKeys = filterKeys + '&modelProviderId=' + keyIds.join(",");
            }
        }
        if (params.request.filterModel && params.request.filterModel['status']) {
            if (params.request.filterModel['status'].values) {
                filterKeys = filterKeys + '&status=' + params.request.filterModel['status'].values;
            }
        }
        if (params.request.filterModel && params.request.filterModel['updateStatus']) {
            if (params.request.filterModel['updateStatus'].values) {
                filterKeys = filterKeys + '&updateStatus=' + params.request.filterModel['updateStatus'].values?.toString().toUpperCase();
            }
        }
        if (params.request.filterModel && params.request.filterModel['finscore']) {
            const fromValue = params.request.filterModel['finscore'].filter;
            const toValue = params.request.filterModel['finscore'].filterTo;
            const filterValue = fromValue + '-' + toValue;
            filterKeys = filterKeys + '&finscore=' + filterValue;
        }
        if (params.request.filterModel && params.request.filterModel['isTaxManaged']) {
            if (params.request.filterModel['isTaxManaged'].values) {
                filterKeys = filterKeys + '&isTaxManaged=' + params.request.filterModel['isTaxManaged'].values
                  .map((value: string) => this.formatYesNoToBoolean(value)); //
            }
        }
        if (params.request.filterModel && params.request.filterModel['isSociallyResponsible']) {
            if (params.request.filterModel['isSociallyResponsible'].values) {
                filterKeys = filterKeys + '&isSociallyResponsible=' + params.request.filterModel['isSociallyResponsible'].values
                  .map((value: string) => this.formatYesNoToBoolean(value)); //
            }
        }
        if (params.request.filterModel && params.request.filterModel['riskTolerance.label']) {
            if (params.request.filterModel['riskTolerance.label'].values) {
                filterKeys = filterKeys + '&riskTolerance=' + params.request.filterModel['riskTolerance.label'].values
                  .map((value: any) => this.mmcColsService.mapRiskToleranceReversed.get(value));
            }
        }
        if (params.request.filterModel && params.request.filterModel['assetClass.label']) {
            if (params.request.filterModel['assetClass.label'].values) {
                filterKeys = filterKeys + '&assetClass=' + params.request.filterModel['assetClass.label'].values
                  .map((value: any) => this.mmcColsService.mapAssetClassReversed.get(value));
            }
        }
        if (params.request.filterModel && params.request.filterModel['allocationChanges']) {
            if (params.request.filterModel['allocationChanges'].values) {
                filterKeys = filterKeys + '&allocationChanges=' + params.request.filterModel['allocationChanges'].values
                  .map((value: any) => this.mmcColsService.mapAllocationChanges.get(value));
            }
        }
        if (params.request.filterModel && params.request.filterModel['assetType.label']) {
            if (params.request.filterModel['assetType.label'].values) {
                filterKeys = filterKeys + '&assetType=' + params.request.filterModel['assetType.label'].values
                  .map((value: any) => this.mmcColsService.mapAssetTypeReversed.get(value));
            }
        }
        if (params.request.filterModel && params.request.filterModel['costBPs']) {
            if (params.request.filterModel['costBPs'].values) {
                filterKeys = filterKeys + '&costBPs=' + params.request.filterModel['costBPs'].values
                  .map((value: string) => this.formatYesNoToBoolean(value));
            }
        }
        if (params.request.filterModel && params.request.filterModel['sourceId']) {
            if (params.request.filterModel['sourceId'].values) {
                filterKeys = filterKeys + '&informaPsnId=' + params.request.filterModel['sourceId'].values;
            }
        }
        if (params.request.filterModel && params.request.filterModel['modelMarketId']) {
            if (params.request.filterModel['modelMarketId'].values) {
                filterKeys = filterKeys + '&modelId=' + params.request.filterModel['modelMarketId'].values;
            }
        }
        if (params.request.filterModel && params.request.filterModel['currentHoldings']) {
            if (params.request.filterModel['currentHoldings'].filter) {
                filterKeys = filterKeys + '&componentSecurity=' + params.request.filterModel['currentHoldings'].filter;
            }
        }
        if (params.request.filterModel && params.request.filterModel['usedFor']) {
            if (params.request.filterModel['usedFor'].values) {
                filterKeys = filterKeys + '&usedFor=' + params.request.filterModel['usedFor'].values
                  .map((value: any) => this.getUsedForValues(value));
            }
        }
        if (params.request.filterModel && params.request.filterModel['buildingBlockStyle']) {
            if (params.request.filterModel['buildingBlockStyle'].values) {
                filterKeys = filterKeys + '&buildingBlockStyle=' + params.request.filterModel['buildingBlockStyle'].values
                  .map((value: any) => this.getBuildingBlockStyleValues(value));
            }
        }
        if (params.request.filterModel && params.request.filterModel['suggestedMinimum']) {
            let minvalue = params.request.filterModel['suggestedMinimum'].filter;
            let maxvalue = params.request.filterModel['suggestedMinimum'].filterTo;

            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '&suggestedMinimum=' + minmaxvalue;
            }
        }
        if (params.request.filterModel && params.request.filterModel['publishOrAllocationUpdatedDate']) {
            const fromDate = '&fromAllocUpdateDate=' + params.request.filterModel['publishOrAllocationUpdatedDate'].filterFrom;
            const toDate = '&toAllocUpdateDate=' + params.request.filterModel['publishOrAllocationUpdatedDate'].filterTo;
            filterKeys = filterKeys + fromDate + toDate ;
        }

        if (filterKeys) {
            filterKeys = filterKeys.substring(1);
            this.payload.filter = filterKeys;
        }

        this.payload.isExport = "false";
        return this._http.post("/mmc/model-inventory",
          this.payload, {headers: headers, observe: 'response'});

    }
    getMMCDropDowns() {
        let url = `/model-market-service/get-mmc-drop-downs`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    getUsedForDropDown() {
        let url = `/model-market-service/used-for-dropdown`;
        return this._http.get(url, this.httpOptions);
    }
    getModelMarketCount() {
        let url = `/model-market-service/get-model-market-count`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    getModelProviders() {
        return this._http.get("/mmc/get-model-providers", this.httpOptions);
    }
    formatYesNoToBoolean(v: string) {
        if (!v) return false;
        if (v === 'None') return 'none';
        return v.toLowerCase() === 'yes';
    }
    exportMMCModelInventory(): Observable<any> {
        const headers = new HttpHeaders({
         'Content-Type': 'application/json',
         'Cache-Control': 'no-cache',
         'Pragma': 'no-cache',
         'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
         'X-HTTP-Method-Override':'GET',
         'Filter-Item':'items=0-1000'
     });
     //let isExport = 'true';
     this.payload.isExport = "true";
        return this._http.post("/mmc/model-inventory" , this.payload, {headers: headers,observe: 'response'});
     }

    exportModelTargetsAdmin(payload: any): Observable<Blob> {
        payload.filter = payload.isSelectAll ? this.payload.filter ? this.payload.filter : '' : '';
        payload.sort = this.payload.sort;
        return this._http.post('/model-market-service/export-model-targets', payload, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    exportModelTargetsDetails(payload: any) {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });

        payload.filter = payload.isSelectAll ? this.payload.filter ? this.payload.filter : '' : '';
        payload.sort = this.payload.sort;

        let url = `/model-market-service/export-model-targets-for-provider`;
        let options: any =  { headers: headers };
        return this._http.post(url, payload, options).pipe(map(res => this.defineResponse(res)));
    }

    exportFirms() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });
        let url = `/model-market-service/export-firm-details`;
        let options: any =  { headers: headers };
        return this._http.get(url, options).pipe(map(res => this.defineResponse(res)));
    }

    exportAdvisors() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });
        let url = `/model-market-service/export-advisors`;
        let options: any =  { headers: headers };
        return this._http.get(url, options).pipe(map(res => this.defineResponse(res)));
    }

    // exportBillingDetails_(period:any): Observable<any> {
    //     return this._http.get("/mmc/async/monthly-billing-detail-report/"+period, this.httpOptions);
    // }
    exportBillingDetails(period:any): Observable<ArrayBuffer> {
        return this._http.get("/mmc/get-monthly-billing-detail-report/"+period, {
            responseType: 'arraybuffer'
        });
    }


    getMdlFromSrc() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });
        const sourceId: number = Number(this.params.sourceId);
        const params = new HttpParams().set('isPaidModel', this.params.isPaidModel);
        let url = `/model-market-service/informa/models/${sourceId}`;
        return this._http.get(url, { headers, params }).pipe(map(res => this.defineResponse(res)));
    }

    getInformaPsnIds() {
        let url = `/model-market-service/get-informa-psn-ids`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    getModelIds() {
        let url = `/model-market-service/get-model-ids`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    getMMCAgreement() {
        return this._http.get("/mmc/get-mmc-agreements", this.httpOptions);

    }

    accessLimitedCustomModels(modelIdsArr: number []): Observable<Object> {
        const modelIds = modelIdsArr.join(',');
        return this._http.get(`/model-market-service/mmc-custom-models/${modelIds}`, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    showSuccessSubscribeBanner(passData: any) {
        this.subscribeBanner.next(passData);
    }

    filterGridAfterSubscribe(filterData: any) {
        this.filterAfterSubscribe.next(filterData);
    }

    getUsedForValues(usedForValue: string) {
        switch (usedForValue) {
            case "Complete Strategy":
                return "CSTRATEGY";
                break;
            case "Sleeve":
                return "SLEEVE";
                break;
            case "Income":
                return "INCOME";
                break;
            case "custom":
                return "CUSTOM";
                break;
            default:
                return usedForValue;
        }
    }

    getBuildingBlockStyleValues(bbStyleValue: string) {
        //bbStyleValue = bbStyleValue.toUpperCase();
        if (bbStyleValue === 'None') return 'none';
        return bbStyleValue;
    }

    clearCriteria() {
        this.payload = {};
    }

    defineResponse(res: any) {
        return  res && res.data && res.data.irebalResponse ? res.data.irebalResponse : res;
    }
}
